import http from "@/http/aisea/axios";
const resource = "/enterprise/users";

export default {
  search(params) {
    return http.get(`${resource}/search`, {
      params: params
    });
  },

  fetch(userId) {
    return http.get(`${resource}/${userId}`);
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  save(userId, payload) {
    return http.put(`${resource}/${userId}`, payload);
  },

  updateSortOrder(payload) {
    return http.put(`${resource}/sort_order`, payload);
  },

  delete(userId) {
    return http.delete(`${resource}/${userId}`);
  }
};
